<template>
  <div class="app-footer">
    <b-container fluid>
      <b-row align-v="center" class="footer">
        <b-col class="home addBorder" cols="2">
          <router-link tag="div" to="/">
            <home-icon
              :class="{ 'is-active': this.$route.name === 'shopMenu' }"
              class="home-icon"
            />
            <div class="home-string">
              <span>{{ $t('common.home') }}</span>
            </div>
          </router-link>
        </b-col>
        <b-col class="search addBorder" cols="2">
          <router-link tag="div" to="/search">
            <search-icon
              :class="{ 'is-active': this.$route.name === 'search' }"
              class="search-icon"
            />
            <div class="search-string">
              <span>{{ $t('common.search') }}</span>
            </div>
          </router-link>
        </b-col>
        <b-col class="history addBorder" cols="2">
          <router-link tag="div" to="/history">
            <history-icon
              :class="{ 'is-active': this.$route.name === 'history' }"
              class="history-icon"
            />
            <div class="history-string">
              <span>{{ $t('orderHistory.orderHistory') }}</span>
            </div>
          </router-link>
        </b-col>
        <b-col class="logo" cols="6">
          <div
            v-if="bikkuraponInstalled === 1 && isGameEnabled && isWinRateChangeEnabled"
            class="win-rate"
          >
            <img v-if="isSelectedJp" src="@/assets/images/probability_up_jp.png" alt="" />
            <img v-if="isSelectedUs" src="@/assets/images/probability_up_en.png" alt="" />
            <img v-if="isSelectedTw" src="@/assets/images/probability_up_tw.png" alt="" />
            <img v-if="isSelectedCn" src="@/assets/images/probability_up_cn.png" alt="" />
            <img v-if="isSelectedKr" src="@/assets/images/probability_up_kr.png" alt="" />
          </div>

          <play-bikkurapon v-if="bikkuraponInstalled === 1 && isGameEnabled" />
          <div v-else class="logo-area">
            <template v-if="isMuten">
              <img v-if="isApp" src="@/assets/images/logo_muten.svg" class="muten-logo-image" />
              <img v-else src="@/assets/images/logo_muten_white.svg" class="muten-logo-image" />
            </template>
            <template v-else>
              <img v-if="isApp" src="@/assets/images/logo_kurazushi_white.svg" class="logo-image" />
              <img v-else-if="!isUs" src="@/assets/images/logo_kurazushi.svg" class="logo-image" />
              <img v-else-if="isUs" src="@/assets/images/welcome-us/logo.svg" class="logo-image" />
            </template>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import config from '@/config/config'
import PlayBikkurapon from '@/components/footer/PlayBikkurapon'
import HomeIcon from '@/components/images/HomeIcon'
import SearchIcon from '@/components/images/SearchIcon'
import HistoryIcon from '@/components/images/HistoryIcon'

export default {
  components: {
    PlayBikkurapon,
    HomeIcon,
    SearchIcon,
    HistoryIcon,
  },
  computed: {
    ...mapGetters({
      gameEnabled: 'seat/getGameEnabled',
      isPreOrder: 'seat/getIsPreOrder',
      shopId: 'seat/getShopId',
      bikkuraponInstalled: 'seat/getBikkuraponInstalled',
      winRateChangeEnabled: 'seat/getWinRateChangeEnabled',
      sideMenuBikkuraponGameEnabled: 'seat/getSideMenuBikkuraponEnabled',
      language: 'setting/getLanguage',
    }),
    isWinRateChangeEnabled() {
      return this.winRateChangeEnabled === 1
    },
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
    isMuten() {
      // 無添蔵の店舗一覧と、shopIDが合致するなら無添蔵のロゴを使用する
      return config.mutenShops.indexOf(this.shopId) >= 0
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
    isSelectedJp() {
      return this.language === 'ja'
    },
    isSelectedUs() {
      return this.language === 'us'
    },
    isSelectedTw() {
      return this.language === 'zh-tw'
    },
    isSelectedCn() {
      return this.language === 'zh-cn'
    },
    isSelectedKr() {
      return this.language === 'kr'
    },
    isGameEnabled() {
      return this.isPreOrder
        ? false
        : this.sideMenuBikkuraponGameEnabled === 1 && this.gameEnabled === 1
    },
  },
}
</script>
<style lang="scss" scoped>
.app-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50px;
  background: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  z-index: 20;
  color: #242424;
  .is-app & {
    color: #fff;
    background: #242424;
    box-shadow: none;
  }
}
.footer {
  > div {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .home {
    @media (max-width: 576px) {
      padding: 0;
    }
    > div {
      height: 35px;
      justify-content: center;
      align-items: center;
      text-align: center;
      @media (max-width: 576px) {
        padding: 0;
        padding-right: 0;
      }
    }
    &-string {
      display: block;
      line-height: 1;
      font-size: 10px;
    }
  }
  .search {
    @media (max-width: 576px) {
      padding: 0;
    }
    > div {
      height: 35px;
      justify-content: center;
      align-items: center;
      text-align: center;
      @media (max-width: 576px) {
        padding: 0;
        padding-right: 0;
      }
    }
    &-string {
      display: block;
      line-height: 1;
      font-size: 10px;
    }
  }
  .history {
    @media (max-width: 576px) {
      padding: 0;
    }
    > div {
      height: 35px;
      justify-content: center;
      align-items: center;
      text-align: center;
      @media (max-width: 576px) {
        padding: 0;
        padding-right: 0;
      }
    }
    &-string {
      display: block;
      line-height: 1;
      font-size: 10px;
    }
  }
  .logo-area {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    .muten-logo-image {
      max-width: 100%;
      max-height: 100%;
    }
    .logo-image {
      width: 48px;
    }
  }

  .logo {
    padding: 0 12px 0 5px;

    @media (max-width: 375px) {
      padding-left: 0;
    }
  }
  .win-rate {
    width: 55px;
    min-width: 45px;
    margin-top: -10px;

    @media (max-width: 359px) {
      min-width: 40px;
    }
    img {
      width: 100%;
    }
  }
}
.addBorder::after {
  position: absolute;
  content: '';
  top: 12;
  right: 0;
  height: 30px;
  width: 1px;
  background: #ccc;
  .is-app & {
    background: #414141;
  }
}
.home-icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  vertical-align: top;
  fill: none;
  stroke-width: 1.5;
  stroke: #ccc;
  &.is-active {
    fill: #000;
    stroke: none;
  }
  .is-app & {
    stroke: #999;
    &.is-active {
      fill: #fff;
      stroke: none;
    }
  }
}
.search-icon,
.history-icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  vertical-align: top;
  fill: none;
  stroke: #ccc;
  stroke-width: 2;
  stroke-linecap: round;
  &.is-active {
    stroke: #242424;
  }
  .is-app & {
    stroke: #999;
    &.is-active {
      stroke: #fff;
    }
  }
}
</style>
